// extracted by mini-css-extract-plugin
module.exports = {"container":"OnsiteDetailsPage_container__bd5z6","innerContainer":"OnsiteDetailsPage_innerContainer__1C7Jf","spinner":"OnsiteDetailsPage_spinner__2iRcd"};